/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnalyticTable from 'components/kea/tables/AnalyticTable';
import CardContainer from 'components/kea/CardContainer';
import { getRelatedProductsByView } from 'actions';
import { linkToProductDetail } from 'util/appUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const RelatedProductsByView = ({ productId }) => {
  const localizeMessage = useLocalizedMessage();
  const dispatch = useDispatch();
  const { analytics: { products, timeframe }, app: { currentShop } } = useSelector((str) => str);
  const { relatedByView: { isFetching, data, error } } = products;

  useEffect(() => {
    dispatch(getRelatedProductsByView(currentShop, timeframe, productId));
  }, [timeframe, productId]);

  const headCells = [
    {
      id: 'name',
      numeric: false,
      label: localizeMessage('analytics.table.productName'),
      sortKey: 'nameText',
    },
    { id: 'count', numeric: true, label: localizeMessage('analytics.table.views') },
  ];

  return (
    <CardContainer
      headerId="search.analytics.relatedProductsByView.header"
      styleName="noMargin"
      tableSurface
      isFetching={isFetching}
      error={error}
    >
      <AnalyticTable
        rows={data.map((e) => ({
          ...e,
          nameText: e.name,
          name: linkToProductDetail(currentShop, e.name, e.id),
        }))}
        headCells={headCells}
        orderById="count"
        emptyMessageId="analytics.product.relatedViews.empty"
      />
    </CardContainer>

  );
};

export default RelatedProductsByView;
